const globals = {
    fullName: '',
  };
  
export default globals;  